const dict = {
  uk: {
    special: {
      free: 'БЕЗКОШТОВНО',
      expired: 'Час акції закінчився',
      defaultCta: 'Дізнатися більше',
      maybeLater: 'Можливо, пізніше',
    },
    personalized: {
      welcomeLevel: 'Вітаємо! Ваш рівень: {{level}}',
      subtitle: 'Персональні пропозиції для вас',
      discountBanner: 'ЗНИЖКА {{percent}}%',
      discountBannerSuffix: 'на перше заняття та товари',
      coursesTitle: 'Курси для рівня {{level}}',
      discountBadge: '-{{percent}}%',
      details: 'Детальніше',
      currency: 'грн',
      currencyPerMonth: 'грн/міс',
      free: 'Безкоштовно',
      groupsTitle: 'Групові заняття',
      firstLessonDiscount: 'перший урок -{{percent}}%',
      firstClubDiscount: 'перший клуб -{{percent}}%',
      firstDiscount: 'перший -{{percent}}%',
      studentsCount: '{{current}}/{{max}} учнів',
      startDate: 'Старт: {{date}}',
      join: 'Приєднатися',
      clubsTitle: 'Клуби',
      productsTitle: 'Навчальні матеріали',
      addToCart: 'Додати в кошик',
      individualTitle: 'Індивідуальне навчання',
      bookLesson: 'Записатися на урок',
      bookFreeConsult: 'Записатися на безкоштовну консультацію',
      yourName: 'Ваше ім\'я',
      phone: 'Телефон',
      preferredTime: 'Зручний час для дзвінка',
      morning: 'Ранок (9:00-12:00)',
      afternoon: 'День (12:00-17:00)',
      evening: 'Вечір (17:00-20:00)',
      submitting: 'Відправка...',
      requestConsult: 'Замовити консультацію',
      consultSuccess: 'Дякуємо! Ми зв\'яжемося з вами найближчим часом.',
      viewLater: 'Переглянути пізніше',
    },
    booking: {
      title: 'Нове бронювання (після пробного уроку)',
      pickStudent: 'Оберіть студента',
      searchStudent: 'Пошук студента...',
      pickProgramFor: 'Оберіть програму для {{name}}',
      noCoursesYet: 'Курси не знайдено. Створіть курс спочатку.',
      lessonPriceUah: '{{price}} грн/урок',
      back: 'Назад',
      pickTeacherAndTime: 'Оберіть викладача та час',
      methodAuthor: 'Автор методики',
      authorLessonTitle: 'Заняття з автором методики',
      authorLessonPrice: 'Вартість індивідуального заняття з цим викладачем — {{price}} грн (вища за стандартну). Групові заняття та клуби не змінюються в ціні.',
      noSlots: 'Немає доступних слотів',
      confirmBooking: 'Підтвердіть бронювання',
      studentLabel: 'Студент:',
      programLabel: 'Програма:',
      teacherLabel: 'Викладач:',
      timeLabel: 'Час:',
      authorPriceLabel: 'Ціна заняття (автор методики):',
      priceUah: '{{price}} грн',
      rulesPrefix: 'Я ознайомився з',
      rulesLink: 'правилами оплати та скасування занять',
      creating: 'Створення...',
      createBooking: 'Створити бронювання',
      createFailed: 'Не вдалося створити бронювання',
      bookingConfirmed: 'Бронювання підтверджено!',
      bookingCreated: 'Бронювання створено',
      done: 'Готово',
      studentLevelPlaceholder: '{{level}}',
      day: {
        mon: 'Понеділок',
        tue: 'Вівторок',
        wed: 'Середа',
        thu: 'Четвер',
        fri: 'П\'ятниця',
        sat: 'Субота',
        sun: 'Неділя',
      },
      status: {
        timeExpired: 'Час вийшов',
        dayShort: {
          mon: 'Пн',
          tue: 'Вт',
          wed: 'Ср',
          thu: 'Чт',
          fri: 'Пт',
          sat: 'Сб',
          sun: 'Нд',
        },
        confirmedTitle: 'Бронювання підтверджено',
        bonusApplied: 'Бонус 100 грн зараховано!',
        cancelledTitle: 'Бронювання скасовано',
        paymentExhausted: 'Час оплати вичерпано. Оберіть інший час або викладача.',
        viewAlternatives: 'Переглянути альтернативи',
        availableSlots: 'Доступні слоти:',
        seatReservedTitle: 'Місце заброньовано',
        timeLeftLabel: 'Залишилось часу для оплати',
        yourBalance: 'Ваш баланс:',
        balanceAmount: '{{amount}} грн',
        pay: 'Оплатити',
        topUp: 'Поповнити',
        payOnTimeBonus: 'Оплатіть вчасно та отримайте бонус 100 грн!',
      },
    },
  },
  en: {
    special: {
      free: 'FREE',
      expired: 'Offer has expired',
      defaultCta: 'Learn more',
      maybeLater: 'Maybe later',
    },
    personalized: {
      welcomeLevel: 'Welcome! Your level: {{level}}',
      subtitle: 'Personalized offers for you',
      discountBanner: '{{percent}}% OFF',
      discountBannerSuffix: 'on your first lesson and products',
      coursesTitle: 'Courses for level {{level}}',
      discountBadge: '-{{percent}}%',
      details: 'Details',
      currency: 'UAH',
      currencyPerMonth: 'UAH/mo',
      free: 'Free',
      groupsTitle: 'Group lessons',
      firstLessonDiscount: 'first lesson -{{percent}}%',
      firstClubDiscount: 'first club -{{percent}}%',
      firstDiscount: 'first -{{percent}}%',
      studentsCount: '{{current}}/{{max}} students',
      startDate: 'Starts: {{date}}',
      join: 'Join',
      clubsTitle: 'Clubs',
      productsTitle: 'Learning materials',
      addToCart: 'Add to cart',
      individualTitle: 'Individual learning',
      bookLesson: 'Book a lesson',
      bookFreeConsult: 'Book a free consultation',
      yourName: 'Your name',
      phone: 'Phone',
      preferredTime: 'Best time to call',
      morning: 'Morning (9:00–12:00)',
      afternoon: 'Afternoon (12:00–17:00)',
      evening: 'Evening (17:00–20:00)',
      submitting: 'Sending...',
      requestConsult: 'Request consultation',
      consultSuccess: 'Thank you! We\'ll get in touch with you shortly.',
      viewLater: 'View later',
    },
    booking: {
      title: 'New booking (after the trial lesson)',
      pickStudent: 'Pick a student',
      searchStudent: 'Search student...',
      pickProgramFor: 'Pick a program for {{name}}',
      noCoursesYet: 'No courses found. Create a course first.',
      lessonPriceUah: '{{price}} UAH/lesson',
      back: 'Back',
      pickTeacherAndTime: 'Pick a teacher and time',
      methodAuthor: 'Method author',
      authorLessonTitle: 'Lesson with the method author',
      authorLessonPrice: 'An individual lesson with this teacher costs {{price}} UAH (higher than standard). Group lessons and clubs remain at their usual price.',
      noSlots: 'No available slots',
      confirmBooking: 'Confirm booking',
      studentLabel: 'Student:',
      programLabel: 'Program:',
      teacherLabel: 'Teacher:',
      timeLabel: 'Time:',
      authorPriceLabel: 'Lesson price (method author):',
      priceUah: '{{price}} UAH',
      rulesPrefix: 'I have read the',
      rulesLink: 'payment and cancellation rules',
      creating: 'Creating...',
      createBooking: 'Create booking',
      createFailed: 'Failed to create booking',
      bookingConfirmed: 'Booking confirmed!',
      bookingCreated: 'Booking created',
      done: 'Done',
      studentLevelPlaceholder: '{{level}}',
      day: {
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
        sun: 'Sunday',
      },
      status: {
        timeExpired: 'Time is up',
        dayShort: {
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat',
          sun: 'Sun',
        },
        confirmedTitle: 'Booking confirmed',
        bonusApplied: '100 UAH bonus credited!',
        cancelledTitle: 'Booking cancelled',
        paymentExhausted: 'The payment window has expired. Pick another time or teacher.',
        viewAlternatives: 'View alternatives',
        availableSlots: 'Available slots:',
        seatReservedTitle: 'Seat reserved',
        timeLeftLabel: 'Time left to pay',
        yourBalance: 'Your balance:',
        balanceAmount: '{{amount}} UAH',
        pay: 'Pay',
        topUp: 'Top up',
        payOnTimeBonus: 'Pay on time and get a 100 UAH bonus!',
      },
    },
  },
};

export default dict;
